import { __awaiter } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2cbe0b9f"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "crypto-stake" };
const _hoisted_2 = { class: "crypto-stake-is" };
const _hoisted_3 = { class: "plan" };
const _hoisted_4 = { class: "crypto-stake-is" };
const _hoisted_5 = { class: "crypto-stake-is" };
const _hoisted_6 = { key: 0 };
const _hoisted_7 = { class: "quantity" };
const _hoisted_8 = { class: "crypto-stake-is" };
const _hoisted_9 = { key: 0 };
const _hoisted_10 = { class: "interest-rate" };
const _hoisted_11 = { class: "btn_container" };
const _hoisted_12 = { class: "container-label" };
const _hoisted_13 = ["checked"];
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "checkmark" }, null, -1));
const _hoisted_15 = ["innerHTML"];
const _hoisted_16 = {
    key: 0,
    class: "invalid_message"
};
const _hoisted_17 = ["disabled"];
const _hoisted_18 = {
    key: 0,
    class: "lds-dual-ring"
};
const _hoisted_19 = {
    key: 1,
    class: "btn-txt"
};
import { ref } from 'vue';
import StakingInterestSchedule from '@/materials/molecules/StakingInterestSchedule.vue';
import { useMessage } from '@/const/messages';
import { useStaking } from '@/logics/staking';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
export default /*#__PURE__*/ _defineComponent({
    props: {
        term: null,
        stakeAmount: null,
        cryptoName: null,
        plan: null,
        decimalPlace: null,
        userInfo: null
    },
    emits: ["onStakeSuccess"],
    setup(__props, { emit }) {
        const props = __props;
        dayjs.extend(timezone);
        dayjs.extend(utc);
        const checked = ref(false); // default check
        const isDisabled = ref(true); // default not disabled
        const spinner = ref(false);
        const DATE_NOW = dayjs().utc(); //default current date&time
        const { STAKECONFIRM, PLANCARD, format } = useMessage();
        const { calculateInterest, postStake } = useStaking();
        const FREE_PLAN = 1;
        const errMsg = ref('');
        const interestAmount = calculateInterest(props.stakeAmount, props.plan.annualInterestRate, props.term, props.decimalPlace);
        const onStake = () => __awaiter(this, void 0, void 0, function* () {
            errMsg.value = '';
            if (checked.value === false) {
                return;
            }
            spinner.value = true;
            isDisabled.value = true;
            try {
                const response = yield postStake(props.plan.id, //store.state.planCardIs,
                props.userInfo.id, //static memberID
                props.stakeAmount);
                if (response) {
                    isDisabled.value = false;
                    spinner.value = false;
                    emit('onStakeSuccess', interestAmount);
                }
            }
            catch (err) {
                spinner.value = false;
                isDisabled.value = true;
                checked.value = false;
                errMsg.value = err;
            }
        });
        const isCheck = (event) => {
            errMsg.value = '';
            isDisabled.value = !event;
            checked.value = event;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(StakingInterestSchedule, {
                    date: _unref(DATE_NOW),
                    term: props.term
                }, null, 8, ["date", "term"]),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", null, _toDisplayString(_unref(format)(_unref(STAKECONFIRM).PLAN)), 1),
                    _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_3, _toDisplayString(props.term === FREE_PLAN ? _unref(format)(_unref(PLANCARD).PLAN) : props.term + _unref(format)(_unref(STAKECONFIRM).DAY)), 1)
                    ])
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", null, _toDisplayString(_unref(format)(_unref(STAKECONFIRM).RATE)), 1),
                    _createElementVNode("div", null, _toDisplayString(__props.plan.annualInterestRate) + "%", 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", null, _toDisplayString(_unref(format)(_unref(STAKECONFIRM).QUANTITY)), 1),
                    (props.cryptoName)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                _createTextVNode(_toDisplayString(props.stakeAmount) + " ", 1),
                                _createElementVNode("span", null, _toDisplayString(props.cryptoName.toUpperCase()), 1)
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", null, _toDisplayString(_unref(format)(_unref(STAKECONFIRM).INTEREST)), 1),
                    (props.cryptoName)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                                _createTextVNode(_toDisplayString(_unref(interestAmount)) + " ", 1),
                                _createElementVNode("span", null, _toDisplayString(props.cryptoName.toUpperCase()), 1)
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("p", null, [
                        _createElementVNode("label", _hoisted_12, [
                            _createElementVNode("input", {
                                type: "checkbox",
                                onChange: _cache[0] || (_cache[0] = (event) => isCheck(event.target.checked)),
                                checked: checked.value
                            }, null, 40, _hoisted_13),
                            _hoisted_14
                        ]),
                        _createElementVNode("span", {
                            innerHTML: _unref(format)(_unref(STAKECONFIRM).TERM),
                            class: _normalizeClass({ 'align-item': _unref(format)(_unref(STAKECONFIRM).PLAN) !== 'Plan' })
                        }, null, 10, _hoisted_15),
                        (errMsg.value !== '')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(errMsg.value), 1))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("button", {
                        disabled: isDisabled.value,
                        class: "act-btn",
                        onClick: onStake
                    }, [
                        (spinner.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_18))
                            : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_unref(format)(_unref(STAKECONFIRM).BTN)), 1))
                    ], 8, _hoisted_17)
                ])
            ]));
        };
    }
});
